module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6ndPld/cover.jpeg?1684255618578",
      "alt": "This image is the cover for the book Soul Healer, Volume 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Soul Healer, Volume 1\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("Everyone had long since gotten tired of seeing an amorous ghost girl chat with a weak scholar. If that was the case, when Taoist Gao Leng met with a ghost of amnesia, what kind of love and hate conflicts would occur between them!")])]), _c('p', [_vm._v("Once, you were a ghost and I was Daoist Ling Xu. Even after using all my strength, I was still unable to become the peerless hero in your heart.")]), _c('p', [_vm._v("Now that you're a puppet, and I'm a spirit doctor, I'll protect you no matter what. The Road to River Styx, the Three Way River, the Resurrection Lily, if fate wills it, I'll accompany you ….")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      An DongNi, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0